import { render } from "./product-info.component.vue?vue&type=template&id=61590210&ts=true"
import script from "./product-info.component.vue?vue&type=script&lang=ts"
export * from "./product-info.component.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__